import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PortalLanding from "@/pages/PortalLanding";
import VerifyCode from "@/pages/VerifyCode";
import PortalDashboard from "@/pages/PortalDashboard";
import SupportRequestNew from "@/pages/SupportRequestNew";
import SupportRequestsList from "@/pages/SupportRequestsList";
import SupportRequestDetail from "@/pages/SupportRequestDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminCustomers from "@/pages/AdminCustomers";
import ImpersonationBanner from "@/components/ImpersonationBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ImpersonationBanner />
        <Routes>
          <Route path="/" element={<PortalLanding />} />
          <Route path="/verify" element={<VerifyCode />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/customers" element={<AdminCustomers />} />
          <Route path="/portal/dashboard" element={<PortalDashboard />} />
          <Route path="/portal/support" element={<SupportRequestNew />} />
          <Route
            path="/portal/support/requests"
            element={<SupportRequestsList />}
          />
          <Route
            path="/portal/support/requests/:requestId"
            element={<SupportRequestDetail />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
